module.exports = __webpack_public_path__ + "static/img/logo.b38024b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 12